import { Helpers } from "../../../../helpers/Helpers";
import { GetAntrepoInByIdResponseData } from "../../../../models/response/antrepoIn/GetAntrepoInByIdResponse";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    antrepoInsRef: any
    antrepoIn: GetAntrepoInByIdResponseData | undefined
}

const AntrepoIns = ({
    antrepoInsRef,
    antrepoIn
}: Props) => {
    return (
        <div className='containerPart' ref={antrepoInsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Bağlı Antrepo Girişi</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>Antrepo Beyan No</th>
                                            <th>Antrepo Beyan Tarihi</th>
                                            <th>Satış Şekli</th>
                                            <th>Gönderici</th>
                                            <th>Alıcı</th>
                                            <th>Gümrük Firması</th>
                                            <th>Gümrük Müdürlüğü</th>
                                            <th>Çıkış Ülkesi</th>
                                            <th>Beyan Kap Adet</th>
                                            <th>Beyan Kap Ağırlık (Kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            (antrepoIn ? [antrepoIn] : []).length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            (antrepoIn ? [antrepoIn] : []).map((item, index) =>
                                                <tr>
                                                    <td><a onClick={() => window.open(window.location.href.split('=')[0].replace('antrepoout', 'antrepoin') + "=" + item.antrepoInId, "_blank")} href='javascript:;'>{item.antrepoDeclarationNo}</a></td>
                                                    <td>{Helpers.dateParser(item.antrepoDeclarationDate, true)}</td>
                                                    <td>{item.saleTypeName}</td>
                                                    <td>{item.senderFirmName}</td>
                                                    <td>{item.receiverFirmName}</td>
                                                    <td>{item.dutyFirmName}</td>
                                                    <td>{item.customsDirectorateName}</td>
                                                    <td>{item.exitCountryName}</td>
                                                    <td>{item.declarationPotQuantity}</td>
                                                    <td>{item.declarationPotWeight}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AntrepoIns;